{
  "common": {
    "next": "Suivant",
    "back": "Retour",
    "loading": "Chargement …",
    "submit": "Envoyer de manière ferme",
    "submitting": "Envoi en cours …",
    "select": "— veuillez sélectionner —",
    "yes": "Oui",
    "dash": "—"
  },
  "nav": {
    "title": "Intégration du client",
    "subtitle": "GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB",
    "impressum": "Mentions légales",
    "datenschutz": "Protection des données"
  },
  "lang": {
    "label": "Langue",
    "de": "Deutsch",
    "en": "English",
    "ar": "العربية",
    "fr": "Français"
  },
  "onboarding": {
    "title": "Intégration du client",
    "subtitle": "Veuillez décrire brièvement les faits de votre affaire. Vous pouvez interrompre à tout moment — vos saisies sont enregistrées automatiquement.",
    "submittedTitle": "Merci — nous avons bien reçu votre demande.",
    "submittedBody": "Vos documents ont été transmis. Nous examinons les faits et reviendrons vers vous sous quelques jours ouvrables.",
    "submittedDashboardPrefix": "Vous pouvez consulter le statut à tout moment dans votre ",
    "submittedDashboardLink": "Tableau de bord",
    "submittedDashboardSuffix": " ou y convenir d’un rendez-vous en ligne.",
    "steps": {
      "sachverhalt": "Faits",
      "fragebogen": "Questionnaire",
      "gegenseite": "Partie adverse",
      "vollmacht": "Procuration",
      "uploads": "Documents",
      "review": "Vérifier et envoyer"
    },
    "sachverhalt": {
      "rechtsgebietLabel": "Domaine du droit",
      "beschreibungLabel": "Brève description de votre demande",
      "beschreibungPlaceholder": "Que s’est-il passé ? Qui est impliqué ? Quelles démarches avez-vous entreprises jusqu’à présent ?",
      "counter": "{{chars}} / 20 000 caractères",
      "minHint": "au moins 3 caractères pour continuer"
    },
    "gegenseite": {
      "hint": "Si aucune partie adverse n’est connue à ce jour, veuillez saisir « — ».",
      "nameLabel": "Nom / société de la partie adverse",
      "anschriftLabel": "Adresse (si connue)",
      "vertretenLabel": "Représentation par avocat de la partie adverse (si connue)"
    },
    "vollmacht": {
      "p1": "Par la suite, nous aurons besoin d’une procuration écrite. Elle vous sera adressée pour signature après examen des faits (soit par voie électronique, soit par courrier).",
      "p2": "Dès à présent, veuillez déclarer votre accord de principe pour que le cabinet GQL Gussone Quecke Legal examine l’affaire et, le cas échéant, vous accepte comme client.",
      "checkbox": "Je charge GQL Gussone Quecke Legal d’examiner les faits exposés ici et de préparer un mandat d’avocat."
    },
    "uploads": {
      "hint": "Veuillez téléverser tous les documents pertinents — en particulier la pièce d’identité (identification conformément à la loi allemande sur le blanchiment d’argent (GwG)), la procuration (si déjà accordée), la correspondance avec la partie adverse et autres moyens de preuve."
    },
    "review": {
      "title": "Récapitulatif",
      "rechtsgebiet": "Domaine du droit",
      "sachverhalt": "Faits",
      "gegenseite": "Partie adverse",
      "vertretenDurch": "Représenté par : {{name}}",
      "vollmachtErklaerung": "Déclaration de procuration",
      "fragebogen": "Questionnaire",
      "unterlagen": "Documents ({{count}})",
      "notReady": "Veuillez d’abord compléter les faits, la partie adverse et la déclaration de procuration."
    },
    "errors": {
      "alreadySubmitted": "Vous avez déjà envoyé.",
      "submitFailed": "L’envoi a échoué — veuillez réessayer plus tard.",
      "unexpected": "Erreur inattendue."
    }
  },
  "rechtsgebiete": {
    "arbeitsrecht": "Droit du travail",
    "mietrecht": "Droit du bail",
    "familienrecht": "Droit de la famille",
    "verkehrsrecht": "Droit de la circulation",
    "strafrecht": "Droit pénal",
    "kartellrecht": "Droit de la concurrence",
    "vergaberecht": "Droit de la commande publique",
    "verwaltungsrecht": "Droit administratif",
    "sonstiges": "Autre"
  },
  "upload": {
    "kategorieLabel": "Catégorie du fichier",
    "kategorien": {
      "ausweis": "Pièce d’identité / identification",
      "vollmacht": "Procuration / mandat",
      "korrespondenz": "Correspondance (lettres, courriels)",
      "beweis": "Moyens de preuve / documents",
      "sonstiges": "Autre"
    },
    "dropHint": "PDF, JPG, PNG, HEIC, ZIP · max. 10 MB par fichier",
    "tooBig": "Le fichier « {{name}} » dépasse 10 MB.",
    "failed": "Le téléversement a échoué — veuillez réessayer.",
    "remove": "Supprimer",
    "removeAria": "Supprimer {{name}}"
  },
  "questionnaire": {
    "title": "Questions sur votre affaire",
    "intro": "Veuillez répondre aux questions suivantes de la manière la plus complète possible. Vos indications nous aident à apprécier correctement votre affaire.",
    "optionalHint": "(facultatif)",
    "requiredHint": "Champ obligatoire",
    "selectPlaceholder": "— veuillez sélectionner —",
    "loading": "Chargement du questionnaire …",
    "answeredCount": "{{answered}} sur {{total}} répondues"
  },
  "legalNotice": {
    "deAuthoritative": "Ce texte juridique fait foi dans sa version allemande. Les traductions sont fournies uniquement pour en faciliter la compréhension."
  },
  "register": {
    "title": "Inscription",
    "subtitle": "Afin que nous puissions enregistrer votre demande de manière structurée, veuillez vous inscrire avec vos données de base. Vous recevrez ensuite un courriel de confirmation.",
    "vorname": "Prénom",
    "nachname": "Nom",
    "geburtsdatum": "Date de naissance",
    "email": "Adresse électronique",
    "required": "Champ obligatoire",
    "einwilligungRequired": "Consentement requis",
    "einwilligung": "Je consens au traitement de mes données aux fins de l'établissement d'un mandat. Les données sont traitées de manière confidentielle et sont soumises au secret professionnel de l'avocat (§ 43a Abs. 2 BRAO).",
    "captchaPlease": "Veuillez confirmer le CAPTCHA.",
    "submit": "Envoyer l'inscription",
    "submitting": "Veuillez patienter …",
    "haveAccount": "Déjà inscrit ?",
    "login": "Se connecter",
    "errCaptcha": "La protection anti-robot a rejeté la tentative. Veuillez résoudre à nouveau le CAPTCHA.",
    "errValidation": "Veuillez vérifier les champs de saisie.",
    "errRateLimit": "Trop d'inscriptions depuis cette connexion. Veuillez réessayer ultérieurement.",
    "errGeneric": "Une erreur est survenue. Veuillez réessayer ultérieurement.",
    "errUnexpected": "Une erreur inattendue est survenue."
  },
  "login": {
    "title": "Connexion",
    "subtitle": "Vous recevrez un lien de connexion à usage unique par courriel. Aucune saisie de mot de passe n'est nécessaire.",
    "email": "Adresse électronique",
    "required": "Champ obligatoire",
    "captchaPlease": "Veuillez confirmer le CAPTCHA.",
    "submit": "Demander un lien de connexion",
    "submitting": "Veuillez patienter …",
    "consumingTitle": "Connexion en cours …",
    "wait": "Veuillez patienter un instant.",
    "sentTitle": "Le lien de connexion a été envoyé",
    "sentBody": "Si l'adresse électronique est enregistrée, nous avons envoyé un lien de connexion. Le lien est valable 15 minutes.",
    "errorTitle": "Connexion impossible",
    "errInvalid": "Le lien de connexion est invalide ou a expiré.",
    "errGeneric": "Échec de la connexion.",
    "errRequest": "Échec de la demande.",
    "errCaptcha": "La protection anti-robot a rejeté la tentative.",
    "newLink": "Demander un nouveau lien",
    "register": "S'inscrire",
    "noAccount": "Pas encore inscrit ?",
    "registerNow": "S'inscrire maintenant"
  },
  "verify": {
    "checkingTitle": "Vérification de la confirmation …",
    "wait": "Veuillez patienter un instant.",
    "successTitle": "Adresse électronique confirmée",
    "successBody": "Merci — votre accès est activé. Vous allez être redirigé vers l'Onboarding …",
    "errorTitle": "Confirmation impossible",
    "errInvalid": "Le lien de confirmation est invalide ou a déjà expiré.",
    "errGeneric": "Échec de la confirmation.",
    "noToken": "Aucun jeton dans le lien.",
    "registerNew": "S'inscrire à nouveau",
    "requestLogin": "Demander un lien de connexion"
  },
  "verifySent": {
    "title": "Le courriel de confirmation a été envoyé",
    "bodyWithEmail": "Nous avons envoyé un lien de confirmation à {{email}}. Veuillez cliquer dessus pour ouvrir l'espace Onboarding.",
    "bodyNoEmail": "Nous vous avons envoyé un lien de confirmation par courriel. Veuillez cliquer dessus pour ouvrir l'espace Onboarding.",
    "validity": "Le lien est valable 24 heures. Veuillez le cas échéant consulter votre dossier de courriers indésirables.",
    "notArrivedPrefix": "Si le courriel n'arrive pas, vous pouvez ",
    "notArrivedLink": "vous inscrire à nouveau",
    "notArrivedSuffix": "."
  },
  "invite": {
    "checkingTitle": "Vérification de l'invitation …",
    "wait": "Veuillez patienter un instant.",
    "successTitle": "Bienvenue",
    "successBody": "Votre accès est activé. Vous allez être redirigé vers l'Onboarding …",
    "errorTitle": "Invitation impossible",
    "errorInvalid": "Le lien d'invitation est invalide ou a expiré.",
    "errorGeneric": "Échec de l'utilisation.",
    "loginLink": "Demander plutôt un lien de connexion"
  },
  "dashboard": {
    "loading": "Chargement …",
    "notLoggedIn": "Non connecté",
    "welcome": "Bienvenue, {{name}}.",
    "subtitle": "Vous pouvez ici modifier vos données d'onboarding ou convenir d'un rendez-vous.",
    "subtitleWithTax": "Vous pouvez ici modifier vos données d'onboarding, compléter les informations fiscales pour 2021 et 2022 ou convenir d'un rendez-vous.",
    "name": "Nom",
    "email": "Courriel",
    "verifiedSince": "Vérifié depuis",
    "logout": "Se déconnecter",
    "requestH": "Votre demande de client",
    "submitted": "Votre demande a été transmise. Nous examinons les faits et reviendrons vers vous sous quelques jours ouvrés.",
    "draftHint": "Vous avez un brouillon d'onboarding commencé. Vous pouvez le poursuivre à partir de là.",
    "continue": "Poursuivre l'onboarding",
    "startHint": "Décrivez-nous les faits de votre affaire, téléversez les documents pertinents — nous examinons l'affaire et revenons vers vous.",
    "start": "Démarrer l'onboarding",
    "taxH": "Formulaire fiscal Haidar pour 2021 et 2022",
    "taxHint": "Veuillez compléter les informations encore requises pour les déclarations fiscales de la communauté et les déclarations personnelles de 2021 et 2022, puis téléverser les justificatifs. Vos saisies sont enregistrées automatiquement.",
    "taxStart": "Ouvrir le formulaire fiscal",
    "taxContinue": "Poursuivre le formulaire fiscal",
    "taxSubmitted": "Le formulaire fiscal a été transmis pour vérification. Aucune donnée n'est envoyée à ELSTER ou au centre des impôts depuis ce portail.",
    "nachreichungH": "Transmettre des documents complémentaires",
    "nachreichungHint": "Vous pouvez téléverser ici d'autres documents (lettres de licenciement, conventions de rupture, contrat de travail, bulletins de salaire, correspondance, etc.). Les fichiers sont transférés directement dans votre dossier, à condition qu'il ait déjà été créé.",
    "terminH": "Convenir d'un rendez-vous en ligne de 30 minutes",
    "terminHint": "Vous pouvez réserver directement un créneau de 30 minutes avec l'avocat Moritz Quecke. Le rendez-vous a lieu sous forme de réunion Microsoft Teams ; vous recevrez le lien par courriel après la réservation.",
    "bookButton": "Réserver un rendez-vous (ouvre une nouvelle fenêtre)",
    "bookInline": "Ou réservez directement ici dans la fenêtre",
    "bookFrameTitle": "Réserver un rendez-vous",
    "bookSoon": "La page de réservation est en cours de mise en place. Dès qu'elle sera disponible, un bouton de réservation apparaîtra ici."
  },
  "notFound": {
    "title": "Page introuvable",
    "subtitle": "La page demandée n'existe pas.",
    "toRegister": "Vers l'inscription"
  },
  "intake": {
    "title": "Questions sur votre affaire",
    "subtitle": "Veuillez répondre aux questions suivantes, téléverser les documents demandés et accorder la procuration. Vos saisies sont enregistrées automatiquement.",
    "notReady": "Veuillez répondre à toutes les questions obligatoires et accorder la procuration.",
    "noQuestionnaireTitle": "Aucun questionnaire attribué",
    "noQuestionnaire": "Aucun questionnaire spécifique à l’affaire n’est attribué à cet accès. Veuillez utiliser l’inscription générale."
  }
}
